import React, { useState, useEffect } from 'react';
import { FaLinkedinIn, FaTwitter, FaEnvelope,FaMapMarkerAlt,FaPhone,FaFacebookF,FaInstagram } from 'react-icons/fa';
import emailjs from 'emailjs-com';
import '../styles/Contact.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: null,
    loading: false
  });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.animate-on-scroll').forEach(el => {
      observer.observe(el);
    });

    return () => {
      document.querySelectorAll('.animate-on-scroll').forEach(el => {
        observer.unobserve(el);
      });
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setFormStatus({ submitted: false, error: null, loading: true });
      const result = await emailjs.send(
       process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );

      if (result.status !== 200) {
        throw new Error('Failed to submit the form');
      }

      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });

      setFormStatus({ submitted: true, error: null, loading: false });
    } catch (error) {
      setFormStatus({ submitted: false, error: error.message, loading: false });
    }
  };

  return (
    <div className="contact-page">
      {/* Main Content */}
      <main className="contact-container">
        {/* Contact Section */}
        <section className="contact-header fade-in animate-on-scroll">
          <h2 className="contact-title">Contact Us</h2>
          <p className="contact-subtitle">
            Get in touch with us for inquiries, collaborations, or support.
          </p>
        </section>
        
        <section className="contact-content">
          {/* Office Details */}
          <div className="office-details animate-on-scroll">
            <h3 className="section-titlec">Our Office</h3>
           <div className="footer-column">
    <p className="contact-item">
      <span className="contact-icon" aria-hidden="true"><FaMapMarkerAlt /></span>
  <a 
    className="contact-linkc" 
    href="https://maps.google.com/?q=BS-1,+Ground+floor,+Manik+Arcade,+Chetana+Nagar,+Kalda+Corner,+Chhatrapati+Sambhajinagar,+Maharashtra+431005" 
    target="_blank" 
    rel="noopener noreferrer"
>
    BS-1, Ground floor, Manik Arcade, Chetana Nagar, Kalda Corner, Chhatrapati Sambhajinagar, Maharashtra 431005
</a>
    </p>
    <p className="contact-item">
      <span className="contact-icon" aria-hidden="true"><FaPhone /></span>
      <a className="contact-linkc" href="tel:+918850-694241">+91 8850-694241</a>
    </p>
    <p className="contact-item">
      <span className="contact-icon" aria-hidden="true"><FaEnvelope /></span>
      <a className="contact-linkc" href="mailto:Info@drbhupatpharma.com">Info@drbhupatpharma.com</a>
    </p>
</div>
            <div className="social-linksc">
                     <a href="#" className="social-linkc" aria-label="Facebook"><FaFacebookF  size={20} color='#3e9ed8'/></a>
                     <a href="#" className="social-linkc" aria-label="Twitter"><FaTwitter  size={20} color='#3e9ed8'/></a>
                     <a href="https://www.linkedin.com/company/drbhupatpharma/" className="social-linkc" aria-label="LinkedIn"><FaLinkedinIn size={20} color='#3e9ed8' /></a>
                     <a href="#" className="social-linkc" aria-label="Instagram"><FaInstagram  size={20} color='#3e9ed8'/></a>
            </div>
          </div>
          
          {/* Contact Form */}
          <div className="contact-form-container animate-on-scroll">
            <h3 className="section-titlec">Send a Message</h3>
                          {formStatus.submitted ? (
                <div className="success-message">
                  <p>Thank you for reaching out! We'll get back to you soon.</p>
                </div>
              ) : (
            <form className="contact-form" onSubmit={handleSubmit}>
              <input 
                type="text" 
                name="name" 
                placeholder="Your Name" 
                value={formData.name}
                onChange={handleChange}
                required 
                className="form-input"
              />
              <input 
                type="email" 
                name="email" 
                placeholder="Your Email" 
                value={formData.email}
                onChange={handleChange}
                required 
                className="form-input"
              />
              <input 
                type="tel" 
                name="phone" 
                placeholder="Your Phone Number" 
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
              <textarea 
                name="message" 
                placeholder="Your Message" 
                value={formData.message}
                onChange={handleChange}
                required 
                className="form-textarea"
              ></textarea>
              
              <button 
                type="submit" 
                className="submit-button"
                disabled={formStatus.loading}
              >
                {formStatus.loading ? 'Sending...' : 'Send Message'}
              </button>
              {formStatus.error && (
                <p className="form-error">Error: {formStatus.error}</p>
              )}
            </form>
              )}
          </div>
        </section>
        
        {/* Google Maps Section */}
        <section className="map-section animate-on-scroll">
          <h3 className="section-title">Find Us on Google Maps</h3>
          <div className="map-container">
            <iframe 
              id="googleMap" 
              className="google-map" 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.759881920784!2d72.82965427528895!3d19.118055349747137!2m3!1f0!2f0!3f0!2m3!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b63f2bf7c60f%3A0xe5d9db9a6f4d4d64!2s123%20Pharma%20Street%2C%20Mumbai%2C%20India!5e0!3m2!1sen!2sin!4v1710000000000" 
              allowFullScreen 
              loading="lazy"
              title="Google Maps Location"
            ></iframe>
          </div>
        </section>
      </main>
    </div>
  );
};

export default ContactPage;